<div mat-dialog-title>FAQ</div>
<mat-divider></mat-divider>
<mat-dialog-content>
	<ol class="faq-ol">
		<li>
			<div class="faq-title">
				{{ "faq.whoIsPSTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.whoIsPSDesc" | translate }}
				<a
					href="https://www.bnm.gov.my/index.php?ch=li_fin_adv&pg=li_fin_adv&ac=3#gsc.tab=0"
					target="blank"
					>{{ "faq.whoIsPSLink" | translate }}</a
				>
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faqTakaful.renewInsAndRoadtaxTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.renewInsAndRoadtaxDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faqTakaful.instantQuoteInsurersTitle" | translate }}
			</div>
			<div class="faq-desc">
				<ol class="child-ol">
					<li>Etiqa General Takaful Berhad</li>
					<li>Syarikat Takaful Malaysia Am Berhad</li>
					<li>Takaful Ikhlas General Berhad</li>
				</ol>
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faqTakaful.otherInsurersTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.otherInsurersDesc1" | translate }}
				<ol class="child-ol" style="margin-left: 10px">
					<li>Zurich General Takaful Malaysia Berhad</li>
				</ol>
				{{ "faq.otherInsurersDesc2" | translate }}

				<ol
					style="list-style-type: lower-alpha; margin-left: 10px"
					class="child-ol"
				>
					<li>{{ "faq.callDesc" | translate }}</li>
					<li>{{ "faq.whatsappDesc" | translate }}</li>
					<li>{{ "faq.emailDesc" | translate }}</li>
				</ol>
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.tncRedeemPromoTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.tncRedeemPromoDesc1" | translate }}
				<ul class="child-ul">
					<li>{{ "faq.tncRedeemPromoDesc2" | translate }}</li>
					<li>{{ "faqTakaful.tncRedeemPromoDesc3" | translate }}</li>
					<li>{{ "faq.tncRedeemPromoDesc4" | translate }}</li>
					<li>{{ "faq.tncRedeemPromoDesc5" | translate }}</li>
				</ul>
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.forgotExpiryDateTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.forgotExpiryDateDesc" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.whoCanUseServiceTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.whoCanUseServiceDesc" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faqTakaful.benefitsOfRenewTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.benefitsOfRenewDesc1" | translate }}
				<br /><br />
				{{ "faq.benefitsOfRenewDesc2" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.renewOnlineSafetyTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.renewOnlineSafetyDesc" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.vehiclesToRenewTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.vehiclesToRenewDesc1" | translate }}
				<br /><br />
				{{ "faq.vehiclesToRenewDesc2" | translate }}
				<span class="color-blue">policystreet.com/motorcycle</span>
				{{ "faqTakaful.vehiclesToRenewDesc3" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.transactionSucessTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.transactionSucessDesc1" | translate }}
				<br /><br />
				{{ "faq.callDesc" | translate }}
				<br /><br />
				{{ "faq.whatsappDesc" | translate }}
				<br /><br />
				{{ "faq.emailDesc" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.paymentOptionsTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.paymentOptionsDesc1" | translate }}
				<ul style="list-style-type: circle; margin-left: 10px" class="child-ul">
					<li>{{ "faq.paymentOptionsDesc2" | translate }}</li>
					<li>{{ "faq.paymentOptionsDesc3" | translate }}</li>
					<li>{{ "faq.paymentOptionsDesc4" | translate }}</li>
				</ul>
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.renewIfOutstandingSummonTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.renewIfOutstandingSummonDesc" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faqTakaful.receivePolicyTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.receivePolicyDesc" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.receiveRoadtaxTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.receiveRoadtaxDesc1" | translate }}
				<ul style="list-style-type: circle; margin-left: 10px" class="child-ul">
					<li>{{ "faq.receiveRoadtaxDesc2" | translate }}</li>
					<li>{{ "faq.receiveRoadtaxDesc3" | translate }}</li>
					<li>{{ "faq.receiveRoadtaxDesc4" | translate }}</li>
				</ul>
				{{ "faq.receiveRoadtaxDesc5" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.chargesOfRenewalTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.chargesOfRenewalDesc" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.viewPaymentTransactionTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.viewPaymentTransactionDesc" | translate }}
			</div>
		</li>

		<li>
			<div class="faq-title">
				{{ "faq.receiptUponPaymentTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.receiptUponPaymentDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.printRegCardTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.printRegCardDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.paymentRejectedTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.paymentRejectedDesc1" | translate }}
				<br /><br />
				{{ "faq.paymentRejectedDesc2" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.cancelAndRefundTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.cancelAndRefundDesc1" | translate }}
				<br /><br />
				{{ "faq.cancelAndRefundDesc2" | translate }}
				<br /><br />
				{{ "faq.callDesc" | translate }}
				<br /><br />
				{{ "faq.whatsappDesc" | translate }}
				<br /><br />
				{{ "faq.emailDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.contactForAssistTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.contactForAssistDesc1" | translate }}
				<br /><br />
				{{ "faq.callDesc" | translate }}
				<br /><br />
				{{ "faq.whatsappDesc" | translate }}
				<br /><br />
				{{ "faq.emailDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.serviceAvailableTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.serviceAvailableDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faqTakaful.makeClaimTitle" | translate }}
			</div>
			<div class="faq-desc">
				<ol class="child-ol">
					<li>Etiqa General Takaful Berhad - 1-300-88-1007 / 1-800-88-6491</li>
					<li>Syarikat Takaful Malaysia Am Berhad - 1-800-888-788</li>
					<li>Takaful Ikhlas General Berhad – 1-800-88-1186</li>
					<li>Zurich General Takaful Malaysia Berhad - 1-300-888-622</li>
				</ol>
				{{ "faqTakaful.makeClaimDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faqTakaful.vehicleIsStolenTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.vehicleIsStolenDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.replacementCarTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.replacementCarDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.whatIsExcessTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.whatIsExcessDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.whatIsNCDTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faqTakaful.whatIsNCDDesc" | translate }}
			</div>
		</li>
		<li>
			<div class="faq-title">
				{{ "faq.purchasePromilejExpectTitle" | translate }}
			</div>
			<div class="faq-desc">
				{{ "faq.purchasePromilejExpectDesc" | translate }}
			</div>
		</li>
	</ol>
</mat-dialog-content>
